import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ContentsSection } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import {CustomPopup, LoadingBox, RentConditionPopup} from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import {CustomSelect, InputBoxCol2, InputItemBox} from "component/basic/formItems";
import { americanAgeSetting, arrParam, datePramaSet, getDateGap, setDateTime } from "js/function";
import { CarListItem } from "component/product/car";
import {DateSelectPopup, InsurancePopup} from "pages/popup/Popup";
import { FixedPage, FixedSection } from "component/basic";
import { FilterSection } from "component/product/Filter";
import { FixedBox_chkItemBox } from "component/app/subItem";
import { NotItems } from "component/basic/notItems";
import { FixedContents, SubAccordionItem } from "component/product/page";
import {MainDataArea, MainDataTitleBox} from "../../component/main/items";

const RentList = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
	const locationData = location?.state ? location?.state : null;
	const filterSettingData = locationData?.filterData;

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const [dateSelectPopupData,setDateSelectPopupData] =  useState(null);
    const [filterPopupData,setFilterPopupData] =  useState(null);

    const [submitChk,setSubmitChk] =  useState(true);

    const [searchHistoryReSet,setSearchHistoryReSet] =  useState(0);
    const [searchKey,setSearchKey] =  useState(null);

    const [searchOpen,setSearchOpen] =  useState(false);

    const [insurancePopupData,setInsurancePopupData] =  useState(null);
    const [alertPopupData,setAlertPopupData] =  useState(null);

    const [filterDataList,setFilterDataList] =  useState([]);

    const [filter,setFilter] =  useState({
        addr:"제주국제공항",
        startDtm:null,
        endDtm:null,
        birth:null,
        career:2,
        carCategory:[],
		insuranceId:"",
        insuranceName:"슈퍼무제한",
        order:"low_price",
        search:null,
        keyword:null,
        size:null,
        appearance:null,
        maker:null,
        fuel:null,
        year:null,
        option:null,
        drivingMethod:null,
        is_outsourcing: null
    });

    const [tempFilter,setTempFilter] =  useState(null);

    const [subFilter,setSubFilter] =  useState({
        insuranceId:1,
        insuranceName:"슈퍼무제한",
        keyword:null,
        size:null,
        appearance:null,
        maker:null,
        fuel:null,
        year:null,
        option:null
    });

    const [conditionPopupData,setConditionPopupData] =  useState(null);

    const pageDataApi = useGet({
        url: filter?.insuranceId ? `/reservation/car?start_date=${filter?.startDtm ? datePramaSet(filter?.startDtm) : ""}
        &end_date=${filter?.endDtm ? datePramaSet(filter?.endDtm) : ""}
        &birth=${filter?.birth ? filter?.birth.replace(/\.-/g,"") : ""}
        &career=${filter?.career||""}
        ${arrParam(filter?.carCategory,"type[]",false,"id")}
        &search=${filter?.search||""}
        &insurance_id=${filter?.insuranceId||""}
        &order=${filter?.order||""}
        &is_outsourcing=${filter?.is_outsourcing||""}
        ${arrParam(filter?.keyword,"keyword[]")}
        ${arrParam(filter?.size,"size[]")}
        ${arrParam(filter?.appearance,"appearance[]")}
        ${arrParam(filter?.maker,"maker[]")}
        ${arrParam(filter?.fuel,"fuel[]")}
        ${arrParam(filter?.year,"year[]")}
        ${arrParam(filter?.option,"option[]")}
        ${arrParam(filter?.drivingMethod,"driving_method[]")}` : "",
        loginType:"login",
        setLoadingBoxOpen: setLoadingBoxOpen
    });
    const pageData = pageDataApi?.data?.cars;

    const yearApi = useGet({
        url:`/data/year`,
        loginType:"login"
    });
    const yearData = yearApi?.data?.car_years;

    const filterApi = useGet({
        url:`/data`,
        loginType:"login"
    });
    const filterData = filterApi?.data?.types;

    const filterTypeDataApi = useGet({
        url:`/data/type?type=차종`,
        loginType:"login"
    });
    const filterTypeData = filterTypeDataApi?.data?.datas;

    const insuranceApi = useGet({
        url:`/insurance`,
        loginType:"login"
    });
    const insuranceData = insuranceApi?.data?.insurances;

    const optionApi = useGet({
        url:`/data/option`,
        loginType:"login"
    });
    const optionData = optionApi?.data?.data_options;

    const drivingMethodOptionApi = useGet({
        url:`/data/option?driving_method=1`,
        loginType:"login"
    });
    const drivingMethodOptionData = drivingMethodOptionApi?.data?.data_options;

    const searchHistoryApi = useGet({
        url:localStorage.getItem("token") ? `/search/history?reset=${searchHistoryReSet}` : null,
        loginType:"login"
    });
    const searchHistoryData = localStorage.getItem("token") ? searchHistoryApi?.data?.search_histories : null;

    function filterDataCh(key,val){
        let oldData = {...filter};
        oldData[key] = val;
        setFilter(oldData);

        if(key === "search"){
            setSearchKey(null);
        }
    }

    function tempFilterDataCh(key,val){
        let oldData = {...tempFilter};
        oldData[key] = val;
        setTempFilter(oldData);

        if(key === "search"){
            setSearchKey(null);
        }
    }

    function subFilterDataCh(key,val){
        let oldData = {...subFilter};
        oldData[key] = val;
        setSubFilter(oldData);
    }

    function dateSelectPopupOpen(){
		setDateSelectPopupData({
			addClass:"topPopup",
			title:"대여/반납 일시 선택",
			closeType:true,
			closeFunc:(e) => {setDateSelectPopupData(null)}
		});
  	}

    function shStart(){
        if(searchKey && searchKey !== ""){
            filterDataCh("search",searchKey);
            historySave();
            setSearchOpen(false);
        }else{
            filterDataCh("search",searchKey);
        }
    }

    function shReSet(){
        if(!(searchKey && searchKey !== "")){
            filterDataCh("search",searchKey);
        }
    }

    function historySave(data){
        if(submitChk && localStorage.getItem("token")){
            setSubmitChk(false);

            let formData = new FormData();

            if(data){
                if(data?.startDtm){
                    formData.append("start_date", data?.startDtm);
                }
                if(data?.endDtm){
                    formData.append("end_date", data?.endDtm);
                }
                if(data?.insuranceName){
                    formData.append("insurance", data?.insuranceName);
                }
                if(data?.search){
                    formData.append("contents", data?.search);
                }
            }else{
                if(filter?.startDtm){
                    formData.append("start_date", filter?.startDtm);
                }
                if(filter?.endDtm){
                    formData.append("end_date", filter?.endDtm);
                }
                if(filter?.insuranceName){
                    formData.append("insurance", filter?.insuranceName);
                }
                if(searchKey){
                    formData.append("contents", searchKey);
                }
            }

            fatchSet.FatchApi({
                type:"POST",
                loginType: "login",
                formDataItem: formData,
                url: `/search/history/register`,
                success: (apiData) => {
                    setSubmitChk(true);
                    
                    setSearchHistoryReSet(searchHistoryReSet + 1);
                },
                err: (apiData) => {
                    setSubmitChk(true);
                }
            })
        }
    }

    function historyDel(id){
        if(submitChk){
            setSubmitChk(false);

            fatchSet.FatchApi({
                type:"DELETE",
                loginType: "login",
                url: `/search/history/delete?history_id=${id}`,
                success: (apiData) => {
                    setSubmitChk(true);
                    
                    setSearchHistoryReSet(searchHistoryReSet + 1);
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                }
            })
        }
    }

    function subFilterFilterKey(data){
        let filterKey = "";

        if(data === "인기 키워드"){
            filterKey = "keyword";
        }
        if(data === "크기"){
            filterKey = "size";
        }
        if(data === "외형"){
            filterKey = "appearance";
        }
        if(data === "제조사"){
            filterKey = "maker";
        }
        if(data === "유종"){
            filterKey = "fuel";
        }
        if(data === "옵션"){
            filterKey = "option";
        }

        return filterKey;
    }

    function subFilterAllChk(data){
        let allChk = false;

        if(data === "인기 키워드" || data === "크기" || data === "외형" || data === "제조사" || data === "유종"){
            allChk = true;
        }

        return allChk;
    }

    function subFilterDataSet(type){
        let filterOld = {...filter};
        let subFilterOld = {...subFilter};

        if(type === "open"){
            subFilterOld.insuranceId = filterOld?.insuranceId;
            subFilterOld.insuranceName = filterOld?.insuranceName;
            subFilterOld.keyword = filterOld?.keyword;
            subFilterOld.size = filterOld?.size;
            subFilterOld.appearance = filterOld?.appearance;
            subFilterOld.maker = filterOld?.maker;
            subFilterOld.fuel = filterOld?.fuel;
            subFilterOld.year = filterOld?.year;
            subFilterOld.option = filterOld?.option;

            setSubFilter(filterOld);
        }else{
            filterOld.insuranceId = subFilterOld?.insuranceId;
            filterOld.insuranceName = subFilterOld?.insuranceName;
            filterOld.keyword = subFilterOld?.keyword;
            filterOld.size = subFilterOld?.size;
            filterOld.appearance = subFilterOld?.appearance;
            filterOld.maker = subFilterOld?.maker;
            filterOld.fuel = subFilterOld?.fuel;
            filterOld.year = subFilterOld?.year;
            filterOld.option = subFilterOld?.option;

            setFilter(filterOld);
        }
    }

    function insurancePopupOpen() {
        let ragChk = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/g;

        if (tempFilter?.birth && ragChk.test(tempFilter?.birth.replace(/\./g, ""))) {
            setInsurancePopupData({
                addClass: null,
                title: "자차보험 선택",
                closeType: true,
                closeFunc: (e) => {
                    setInsurancePopupData(null)
                }
            });
        } else {
            setAlertPopupData({
                addClass: "subTitle_line_0",
                title: "운전자 생년월일 입력",
                subTitle: "운전자 생년월일을 입력해주세요",
                closeType: true,
                closeFunc: (e) => {
                    setAlertPopupData(null)
                },
                closeBtnDel: true,
            });
        }
    }

    useEffect(() => {
        let oldData = {...filter};
        if(insuranceData && !filterSettingData){
            let nowDate = new Date();

            nowDate.setDate(nowDate.getDate() + 1);
            oldData.startDtm = `${setDateTime(nowDate,"yymmdd","hymd")} 10:00`;
            nowDate.setDate(nowDate.getDate() + 1);
            oldData.endDtm = `${setDateTime(nowDate,"yymmdd","hymd")} 10:00`;

            oldData.insuranceId = insuranceData[0]?.id;
            oldData.insuranceName = insuranceData[0]?.name;
            
            setFilter(oldData);
        }
    }, [insuranceApi]);

    useEffect(() => {
        let oldData = {...filter};
        let nowDate = new Date();

        if(filterSettingData){
            oldData.addr = filterSettingData?.addr;

            nowDate.setDate(nowDate.getDate() + 1);
            oldData.startDtm = filterSettingData?.startDtm ? filterSettingData?.startDtm : `${setDateTime(nowDate,"yymmdd","hymd")} 10:00`;

            nowDate.setDate(nowDate.getDate() + 1);
            oldData.endDtm = filterSettingData?.endDtm ? filterSettingData?.endDtm : `${setDateTime(nowDate,"yymmdd","hymd")} 10:00`;

            if(filterSettingData?.birth){
                oldData.birth = filterSettingData?.birth;
            }
            if(filterSettingData?.career){
                oldData.career = filterSettingData?.career;
            }
            if(filterSettingData?.carCategory){
                oldData.carCategory = filterSettingData?.carCategory;
            }
            if(filterSettingData?.insuranceId){
                oldData.insuranceId = filterSettingData?.insuranceId;
                oldData.insuranceName = filterSettingData?.insuranceName;
            }
            
            if(filterSettingData?.search){
                oldData.search = filterSettingData?.search;
                setSearchKey(filterSettingData?.search);

                setTimeout(() => {
                    historySave(oldData);
                    setSearchOpen(false);
                    
                    setSearchKey(null);
                }, 200);
            }
            
            setFilter(oldData);
        }else{
            nowDate.setDate(nowDate.getDate() + 1);
            oldData.startDtm = `${setDateTime(nowDate,"yymmdd","hymd")} 10:00`;

            nowDate.setDate(nowDate.getDate() + 1);
            oldData.endDtm = `${setDateTime(nowDate,"yymmdd","hymd")} 10:00`;

            setFilter(oldData);
        }

        setLoadingBoxOpen(false);
    }, []);

    useEffect(() => {
        if (pageDataApi.success) {
            setLoadingBoxOpen(false);
        } else {
            setLoadingBoxOpen(true);
        }
    }, [pageDataApi])

    useEffect(() => {
        if (filter) {
            setTempFilter(filter)
        }
    }, [filter])

    useEffect(() => {
        if (pageData && pageData.length === 0) {
            setConditionPopupData({
                closeFunc:(e) => {setConditionPopupData(null)}
            })
        }
    }, [pageData])

    useEffect(() => {
        if (filterData) {
            let newFilterData = []
            newFilterData[3] = "year";

            filterData.forEach((item) => {
                if (item.type === "외형") {
                    newFilterData[0] = item
                } else if (item.type === "크기") {
                    newFilterData[1] = item
                } else if (item.type === "유종") {
                    newFilterData[2] = item
                } else if (item.type === "제조사") {
                    newFilterData[4] = item
                } else if (item.type === "인기 키워드") {
                    newFilterData[5] = item
                }
            })

            setFilterDataList(newFilterData);
        }
    }, [filterData])

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg pcFilterContens"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={() => {
                        navigate(-1)
                    }}
                    headTitle={filter?.search ? `"${filter?.search}" 검색 결과` : "차량 리스트"}
                    rightBtnsArr={[
                        {
                            addClass: "",
                            func: () => {
                                subFilterDataSet("open");
                                setFilterPopupData({
                                    addClass: "mItemT radiusNone filterPopup",
                                    title: null,
                                    subTitle: null,
                                    closeType: true,
                                    closeBtnDel: true,
                                    closeFunc: (e) => {
                                        setFilterPopupData(null)
                                    },
                                });
                            },
                            contents: "<img src='/assets/images/icon/filter.svg'/>"
                        },
                        {
                            addClass: "",
                            func: () => {
                                setSearchOpen(!searchOpen)
                            },
                            contents: "<img src='/assets/images/icon/header_sh.svg'/>"
                        }
                    ]}
                    pageClose={false}
                    activeType={0}
                    closeFunc={() => {
                    }}
                />
                <div className="listFilter pcItemT">
                    <div className="listFilter_section">
                        <InputItemBox
                            inputType={null}
                            boxAddClass="sSize"
                            inputName="<img src='/assets/images/icon/main_filter_icon_0.svg'/> 위치"
                            placeholder="위치 선택"
                            value={filter?.addr}
                            max={null}
                            regexp={null}
                            errMsg={null}
                            readOnly={true}
                            func={(value) => {
                            }}
                        />
                        <InputItemBox
                            inputType={null}
                            boxAddClass="mSize"
                            inputName="<img src='/assets/images/icon/main_filter_icon_1.svg'/> 대여/반납 일시"
                            placeholder="대여/반납 일시 선택"
                            value={filter?.startDtm && filter?.endDtm ? `${setDateTime(filter?.startDtm, "daymmddhh", null)} ~ ${setDateTime(filter?.endDtm, "daymmddhh", null)}` : null}
                            inputSubName={filter?.startDtm && filter?.endDtm ? `${getDateGap(filter?.startDtm, filter?.endDtm, "time", null)} 시간` : null}
                            max={null}
                            regexp={null}
                            errMsg={null}
                            readOnly={true}
                            func={(value) => {
                            }}
                            clickInput={() => {
                                dateSelectPopupOpen()
                            }}
                        />
                        <InputItemBox
                            inputType={null}
                            boxAddClass="sSize"
                            inputName="<img src='/assets/images/icon/main_filter_icon_2.svg'/> 생년월일"
                            inputSubName={filter?.birth && filter?.birth.length >= 10 ? `만 ${americanAgeSetting(filter?.birth)}세` : null}
                            placeholder="YYYY.MM.DD"
                            value={filter?.birth}
                            max={10}
                            regexp={/[^0-9\.]/gi}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            birthSetting={true}
                            errMsg={null}
                            func={(value) => {
                                filterDataCh("birth", value)
                            }}
                        />
                        <CustomSelect
                            boxAddClass="sSize"
                            addClass="absoluteSel"
                            inputName="<img src='/assets/images/icon/main_filter_icon_3.svg'/> 운전 경력"
                            placeholder="운전 경력 선택"
                            value={filter?.career}
                            func={(name, val) => {
                                filterDataCh("career", val)
                            }}
                            disabled={false}
                            valKey="id"
                            nameKey="name"
                            options={[
                                {id: 1, name: "1년 이상"},
                                {id: 2, name: "2년 이상"},
                                {id: 3, name: "3년 이상"}
                            ]}
                        />
                        <CustomSelect
                            boxAddClass="sSize"
                            multiple={true}
                            basicSelText={"전체"}
                            addClass="absoluteSel"
                            inputName="<img src='/assets/images/icon/main_filter_icon_4.svg'/> 대여 희망 차종"
                            placeholder="희망 차종 선택"
                            value={filter?.carCategory}
                            func={(arr) => {
                                filterDataCh("carCategory", arr)
                            }}
                            disabled={false}
                            valKey="id"
                            nameKey="name"
                            options={filterTypeData ? [
                                {id: "all", name: "전체"},
                                ...filterTypeData
                            ] : [{id: "all", name: "전체"}]}
                        />
                    </div>
                </div>
                <FixedPage addClass="reverse listPage">
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass="fixedsection_min pcItemT"
                        addClass="fixedArea_min nonFixed"
                        contentsBox="fixedPage"
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <FilterSection>
                            {insuranceData && insuranceData?.length > 0 ?
                                <FixedBox_chkItemBox
                                    allChk={false}
                                    multiple={false}
                                    addClass=""
                                    title={"자차 보험"}
                                    value={filter?.insuranceId}
                                    data={insuranceData}
                                    func={(id, name) => {
                                        let oldData = {...filter};
                                        oldData.insuranceId = id;
                                        oldData.insuranceName = name;
                                        setFilter(oldData);
                                    }}
                                />
                                : ""}
                            {filterDataList && filterDataList?.length > 0 ?
                                <>
                                    {filterDataList && filterDataList?.map((item, i) => (
                                        item === "year" ?
                                            <FixedBox_chkItemBox
                                                allChk={true}
                                                slideItem={true}
                                                multiple={true}
                                                addClass=""
                                                alignType={"row2"}
                                                title={"연식"}
                                                value={filter?.year}
                                                data={yearData}
                                                func={(arr) => {
                                                    filterDataCh("year", arr)
                                                }}
                                            />
                                            :
                                            <FixedBox_chkItemBox
                                                key={i}
                                                slideItem={true}
                                                allChk={subFilterAllChk(item?.type)}
                                                multiple={true}
                                                alignType={item?.type === "인기 키워드" ? null : "row2"}
                                                addClass=""
                                                title={item?.type}
                                                value={filter[subFilterFilterKey(item?.type)]}
                                                data={item?.datas}
                                                func={(arr) => {
                                                    filterDataCh(subFilterFilterKey(item?.type), arr)
                                                }}
                                            />
                                    ))}
                                </>
                                : ""}
                            <FixedBox_chkItemBox
                                allChk={false}
                                slideItem={true}
                                multiple={true}
                                addClass=""
                                alignType={"row2"}
                                title={"구동방식"}
                                value={filter?.option}
                                data={drivingMethodOptionData}
                                func={(arr) => {
                                    filterDataCh("option", arr)
                                }}
                            />
                            <FixedBox_chkItemBox
                                allChk={false}
                                slideItem={true}
                                multiple={true}
                                addClass=""
                                alignType={"row2"}
                                title={"옵션"}
                                value={filter?.option}
                                data={optionData}
                                func={(arr) => {
                                    filterDataCh("option", arr)
                                }}
                            />
                        </FilterSection>
                    </FixedSection>
                    <FixedContents>
                        <div className={`listShSection ${searchOpen ? "shOpen" : ""}`}>
                            <div className="listShSection_cover mItemT" onClick={() => {
                                setSearchOpen(false)
                            }}></div>
                            <div className="listShArea">
                                <div className={`filterShBox`}>
                                    <input
                                        type={"text"}
                                        className="filterSh"

                                        value={searchKey}
                                        placeholder={"차량 모델을 입력하세요"}

                                        onInput={(e) => {
                                            setSearchKey(e.target.value)
                                        }}
                                        onPaste={(e) => {
                                            setSearchKey(e.target.value)
                                        }}
                                        onChange={(e) => {
                                            setSearchKey(e.target.value)
                                        }}
                                        onKeyUp={(e) => {
                                            setSearchKey(e.target.value);
                                            if (e.keyCode == 13 || e.key == "Enter") {
                                                shStart();
                                            }
                                        }}
                                        readOnly={false}
                                        disabled={false}
                                    />
                                    <button type="button" onClick={() => {
                                        shStart();
                                    }} className="btn_filterSh">
                                        <img src="/assets/images/basic/sh.svg"/>
                                    </button>
                                </div>
                                <CustomSelect
                                    boxAddClass="basic pcItemT input200"
                                    addClass="absoluteSel"
                                    inputName={null}
                                    placeholder="차량 인수반납지점"
                                    value={filter?.is_outsourcing}
                                    func={(name, val) => {
                                        filterDataCh("is_outsourcing", val)
                                    }}
                                    disabled={false}
                                    valKey="id"
                                    nameKey="name"
                                    options={[
                                        {id: "0", name: "AMANO 렌터카허브"},
                                        {id: "1", name: "제휴 렌터카사"},
                                    ]}
                                />
                                <CustomSelect
                                    boxAddClass="basic pcItemT"
                                    addClass="absoluteSel"
                                    inputName={null}
                                    placeholder="정렬 선택"
                                    value={filter?.order}
                                    func={(name, val) => {
                                        filterDataCh("order", val)
                                    }}
                                    disabled={false}
                                    valKey="id"
                                    nameKey="name"
                                    options={[
                                        {id: "low_price", name: "가격 낮은 순"},
                                        {id: "high_review", name: "평점 높은 순"},
                                        {id: "recent", name: "최신 순"}
                                    ]}
                                />
                            </div>
                            {localStorage.getItem("token") ?
                                <div
                                    className={`listSh_listBox ${(searchKey && searchKey !== "") ? "listSh_historyOpen" : ""}`}>
                                    <div className="listSh_list_titleBox">
                                        <h1 className="listSh_list_title">최근 검색정보</h1>
                                        <button type="button" className="listSh_list_allDel" onClick={() => {
                                            historyDel()
                                        }}>전체 삭제
                                        </button>
                                    </div>
                                    {searchHistoryData && searchHistoryData?.length > 0 ?
                                        <div className="listSh_historyList">
                                            {searchHistoryData && searchHistoryData?.map((item, i) => (
                                                <div className="listSh_historyListItem" key={i}>
                                                    <button type="button" className="listSh_historyListItem_btn"
                                                            onClick={() => {
                                                                let oldData = {...filter};
                                                                if (item?.start_date) {
                                                                    oldData.startDtm = item?.start_date
                                                                }
                                                                ;
                                                                if (item?.end_date) {
                                                                    oldData.endDtm = item?.end_date
                                                                }
                                                                ;
                                                                if (item?.insurance_id) {
                                                                    oldData.insuranceId = item?.insurance_id;
                                                                    oldData.insuranceName = insuranceData?.filter((el) => el.id === oldData?.insuranceId)[0]?.name;
                                                                }
                                                                ;

                                                                if (item?.contents) {
                                                                    oldData.search = item?.contents
                                                                }
                                                                ;

                                                                setFilter(oldData);
                                                            }}>
                                                        <div className="listSh_historyListItem_icon">
                                                            <img src="/assets/images/icon/shList_icon.svg"/>
                                                        </div>
                                                        <div className="listSh_historyListItem_info">
                                                            <p className="listSh_historyListItem_text">{item.contents}</p>
                                                            {item?.start_date || item?.end_date || item.insurance ?
                                                                <p className="listSh_historyListItem_caption">
                                                                    {`${item?.start_date ? setDateTime(item?.start_date, "daymmddhh", null) : ""}${item?.start_date && item?.end_date ? " ~ " : ""}${item?.end_date ? setDateTime(item?.end_date, "daymmddhh", null) : ""}${item?.start_date && item?.end_date && item.insurance ? "ㅣ" : ""}${item.insurance || ""}`}
                                                                </p>
                                                                : ""}
                                                        </div>
                                                    </button>
                                                    <button type="button" className="listSh_historyListItem_del"
                                                            onClick={() => {
                                                                historyDel(item.id)
                                                            }}>
                                                        <img src="/assets/images/icon/shList_del.svg"/>
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                        :
                                        <NotItems addClass="min" text={`최근 검색정보가 없습니다.`}/>
                                    }
                                </div>
                                : ""}
                            <BtnBox
                                boxType="fixed"
                                addClass="mItemT"
                            >
                                <BtnItem
                                    addClass=""
                                    contents={"검색"}
                                    disabled={false}
                                    func={() => {
                                        shStart();
                                    }}
                                />
                            </BtnBox>
                        </div>
                        {pageData && pageData?.length > 0 ?
                            <>
                                {pageData && pageData?.map((item, i) => (
                                    <CarListItem
                                        key={i}
                                        type="rent"
                                        addClass=""
                                        id={item?.id}
                                        car_image={item?.image_url}
                                        maker={item?.maker}
                                        modelName={item?.name}
                                        passengerNum={item?.passenger_number}
                                        fuelType={item?.fuel}
                                        min_year={item?.min_year}
                                        max_year={item?.max_year}
                                        insuranceName={filter?.insuranceName || null}
                                        is_outsourcing={item?.is_outsourcing}

                                        carOptions={item?.options}

                                        carCategory={item?.type}
                                        eventRate={item?.specialEventRate}
                                        discount_price={item?.discount_price}
                                        original_price={item?.original_price}

                                        mImgChk={true}

                                        stateData={{filterData: filter}}
                                        companyMappedCode={item.companyMappedCode}
                                        modelMappedCode={item.modelMappedCode}
                                    />
                                ))}
                            </>
                            :
                            <NotItems addClass="sectionNotItem" text={`조건에 맞는 차량이 없습니다.`}/>
                        }
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <DateSelectPopup
                popupData={dateSelectPopupData}
                btnType={true}
                subBtnText={"취소"}
                subBtnFunc={() => {
                    setDateSelectPopupData(null);
                }}
                btnText={"선택 완료"}
                btnFunc={(start, end) => {
                    if (conditionPopupData) {
                        let oldData = {...tempFilter};
                        oldData.startDtm = start;
                        oldData.endDtm = end;
                        setTempFilter(oldData);
                    } else {
                        let oldData = {...filter};
                        oldData.startDtm = start;
                        oldData.endDtm = end;
                        setFilter(oldData);
                    }

                    setDateSelectPopupData(null);
                }}
            />
            <CustomPopup data={filterPopupData} toastType={true} basicPB={false}>
                {insuranceData && insuranceData?.length > 0 ?
                    <FixedBox_chkItemBox
                        allChk={false}
                        multiple={false}
                        addClass="titleSizeUp"
                        title={"자차 보험"}
                        alignType="row2"
                        value={subFilter?.insuranceId}
                        data={insuranceData}
                        func={(id, name) => {
                            let oldData = {...subFilter};
                            oldData.insuranceId = id;
                            oldData.insuranceName = name;
                            setSubFilter(oldData);
                        }}
                    />
                    : ""}
                {filterData && filterData?.length > 0 ?
                    <>
                        {filterData && filterData?.map((item, i) => (
                            <SubAccordionItem title={item?.type} addClass="titleSizeUp" key={i}>
                                <FixedBox_chkItemBox
                                    allChk={subFilterAllChk(item?.type)}
                                    multiple={true}
                                    addClass={null}
                                    title={null}
                                    alignType={item?.type === "인기 키워드" ? "" : "row2"}
                                    value={subFilter[subFilterFilterKey(item?.type)]}
                                    data={item?.datas}
                                    func={(arr) => {
                                        subFilterDataCh(subFilterFilterKey(item?.type), arr)
                                    }}
                                />
                            </SubAccordionItem>
                        ))}
                    </>
                    : ""}
                <SubAccordionItem title={"연식"} addClass="titleSizeUp">
                    <FixedBox_chkItemBox
                        allChk={true}
                        multiple={true}
                        addClass=""
                        alignType="row2"
                        title={null}
                        value={subFilter?.year}
                        data={yearData}
                        func={(arr) => {
                            subFilterDataCh("year", arr)
                        }}
                    />
                </SubAccordionItem>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass=""
                        contents={"필터 적용"}
                        disabled={false}
                        func={() => {
                            setFilterPopupData(null);
                            subFilterDataSet();
                        }}
                    />
                </BtnBox>
            </CustomPopup>
            <RentConditionPopup data={conditionPopupData} toastType={true} basicPB={false}>
                <MainDataArea addClass="mainArea mainTopBannerArea">
                    <div className="mainFilterBox" style={{maxWidth: "500px"}}>
                        <div className={"rentFilter_titleArea"}>
                            <h3 className="rentFilter_title">현재 조건에서는 차량을 찾을 수 없습니다.</h3>
                            <h3 className="rentFilter_title">조건을 변경하시면 더 많은 차량을 보실 수 있어요.</h3>
                        </div>
                        <div className="mainFilter_inputBox">
                            <InputItemBox
                                inputType={null}
                                addClass=""
                                inputName="<img src='/assets/images/icon/main_filter_icon_0.svg'/> 위치"
                                placeholder="위치 선택"
                                value={tempFilter?.addr}
                                max={null}
                                regexp={null}
                                errMsg={null}
                                readOnly={true}
                                func={(value) => {
                                }}
                            />
                            <InputItemBox
                                inputType={null}
                                addClass="readOnlyNotColor"
                                inputName="<img src='/assets/images/icon/main_filter_icon_1.svg'/> 대여/반납 일시"
                                placeholder="대여/반납 일시 선택"
                                value={tempFilter?.startDtm && tempFilter?.endDtm ? `${setDateTime(tempFilter?.startDtm, "daymmddhh", null)} ~ ${setDateTime(tempFilter?.endDtm, "daymmddhh", null)}` : null}
                                max={null}
                                regexp={null}
                                errMsg={null}
                                readOnly={true}
                                func={(value) => {
                                }}
                                clickInput={() => {
                                    dateSelectPopupOpen()
                                }}
                            />
                            <InputBoxCol2>
                                <InputItemBox
                                    inputType={null}
                                    addClass=""
                                    inputName="<img src='/assets/images/icon/main_filter_icon_2.svg'/> 운전자 생년월일"
                                    placeholder="YYYY.MM.DD"
                                    value={tempFilter?.birth}
                                    max={10}
                                    regexp={/[^0-9\.]/gi}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    birthSetting={true}
                                    errMsg={null}
                                    func={(value) => {
                                        tempFilterDataCh("birth", value)
                                    }}
                                />
                                <CustomSelect
                                    addClass="absoluteSel"
                                    inputName="<img src='/assets/images/icon/main_filter_icon_3.svg'/> 운전 경력"
                                    placeholder="운전 경력 선택"
                                    value={tempFilter?.career}
                                    func={(name, val) => {
                                        tempFilterDataCh("career", val)
                                    }}
                                    disabled={false}
                                    valKey="id"
                                    nameKey="name"
                                    options={[
                                        {id: 1, name: "1년 이상"},
                                        {id: 2, name: "2년 이상"},
                                        {id: 3, name: "3년 이상"}
                                    ]}
                                />
                            </InputBoxCol2>
                            <CustomSelect
                                multiple={true}
                                basicSelText={"전체"}
                                addClass="absoluteSel"
                                inputName="<img src='/assets/images/icon/main_filter_icon_4.svg'/> 대여 희망 차종"
                                placeholder="대여 희망 차종 선택"
                                value={tempFilter?.carCategory}
                                func={(arr) => {
                                    tempFilterDataCh("carCategory", arr)
                                }}
                                disabled={false}
                                valKey="id"
                                nameKey="name"
                                options={filterTypeData ? [
                                    {id: "all", name: "전체"},
                                    ...filterTypeData
                                ] : [{id: "all", name: "전체"}]}
                            />
                        </div>
                        <BtnItem
                            addClass={`flex gradient`}
                            contents="원하는 차량 검색하기<img src='/assets/images/basic/filter_btn_move.svg'/>"
                            func={() => {
                                insurancePopupOpen()
                            }}
                        />
                    </div>
                </MainDataArea>
            </RentConditionPopup>
            <Footer/>
            <LoadingBox openType={loadingBoxOpen}/>

            <CustomPopup data={alertPopupData} toastType={true}>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"확인"}
                        disabled={false}
                        func={() => {
                            setAlertPopupData(null);
                        }}
                    />
                </BtnBox>
            </CustomPopup>
            <InsurancePopup
                popupData={insurancePopupData}
                data={insuranceData}
                btnType={true}
                subBtnText={"취소"}
                subBtnFunc={()=>{
                    setInsurancePopupData(null);
                }}
                btnText={"차량 검색"}
                btnFunc={(id)=>{
                    let oldData = {...tempFilter};
                    oldData.insuranceId = id;
                    oldData.insuranceName = insuranceData?.filter((el)=>el.id === oldData?.insuranceId)[0]?.name;
                    setTempFilter(oldData);
                    setFilter(oldData)

                    setConditionPopupData(null)
                    setInsurancePopupData(null);
                }}
            />
        </>
    );
};

export default RentList;